/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Rate = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 44 38" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M17.364 31.519a.993.993 0 0 1-.665-.254L3.748 19.678c-2.428-2.222-3.76-5.175-3.76-8.32 0-3.145 1.332-6.098 3.751-8.313 4.43-4.057 11.633-4.056 16.061 0l2.085 1.908 2.085-1.908c4.43-4.056 11.635-4.055 16.062 0 4.166 3.816 4.962 9.717 1.938 14.351a1 1 0 0 1-1.379.291.994.994 0 0 1-.291-1.377c2.482-3.802 1.817-8.654-1.616-11.8-3.686-3.374-9.68-3.375-13.365 0l-3.434 3.145-3.433-3.144c-3.685-3.375-9.68-3.375-13.365 0-2.002 1.834-3.105 4.265-3.105 6.847 0 2.581 1.103 5.014 3.105 6.847l12.942 11.578a.993.993 0 0 1-.665 1.736z" /><path d="M21.886 35.936a.995.995 0 0 1-.672-1.731l14.533-13.19a1 1 0 0 1 1.408.067.994.994 0 0 1-.067 1.405l-14.531 13.19a.995.995 0 0 1-.67.26zm1.308-9.557a3.983 3.983 0 0 1-3.988-3.979 3.984 3.984 0 0 1 3.988-3.979 3.983 3.983 0 0 1 3.987 3.98 3.983 3.983 0 0 1-3.987 3.978zm0-5.968c-1.102 0-1.995.89-1.995 1.99 0 1.097.893 1.987 1.995 1.987 1.1 0 1.993-.89 1.993-1.988a1.992 1.992 0 0 0-1.993-1.989zM34.836 38a3.984 3.984 0 0 1-3.987-3.979 3.983 3.983 0 0 1 3.987-3.98 3.983 3.983 0 0 1 3.988 3.98A3.984 3.984 0 0 1 34.836 38zm0-5.967a1.99 1.99 0 0 0-1.993 1.988 1.99 1.99 0 0 0 1.993 1.988 1.992 1.992 0 0 0 1.995-1.988 1.99 1.99 0 0 0-1.995-1.988z" />
      </g>
    </svg>
  </span>
);

Rate.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Rate.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Rate;
